module.exports = __webpack_public_path__ + "static/media/boy.be5c4cc3.svg";